var render, staticRenderFns
var script = {}
import style0 from "./Menu.vue?vue&type=style&index=0&id=24c940c4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports